import { Sizes } from '../enum-types';
import { JustifyContent } from '../justify-content';

enum DropdownVariant {
   Cta = 'Cta',
   Secondary = 'Secondary',
   Action = 'Action',
   Destructive = 'Destructive',
   DestructiveAction = 'DestructiveAction',
   Light = 'Light',
}

enum DropdownToggleAs {
   Button = 'Button',
   Chip = 'Chip',
}

enum DropdownAutoClose {
   True = 'true',
   False = 'false',
   Inside = 'inside',
   Outside = 'outside',
}

enum DropdownMenuAlignment {
   Left = 'left',
   Right = 'right',
}

export {
   Sizes,
   DropdownVariant,
   DropdownToggleAs,
   DropdownAutoClose,
   JustifyContent,
   DropdownMenuAlignment,
};

export interface AtlDropdownProps {
   toggleLabel: string;
   toggleIconName: string;
   toggleAs: DropdownToggleAs;
   toggleReverseOrder?: boolean;
   toggleClasses?: string;
   variant: DropdownVariant;
   size: Sizes;
   autoClose?: DropdownAutoClose;
   disabled?: boolean;
   menuAlignment?: DropdownMenuAlignment;
}
